import clsx from 'clsx';
import styles from './BlankQuestion.module.scss';
import {
    checkAnswer,
    getMaxLengthStringOfArray,
    getTypeOfResult,
    handleVibrate,
    splitText,
} from '~/utils/common';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { TextButton, ResultBox, IconButton } from '~/components';
import { useTranslation } from 'react-i18next';


function BlankQuestion(
    {
        question,
        audioMap,
        notiCompleteAnAnswer,
        notiContinue,
        updateResult,
        className,
        handlePlay,
        handlePlayByWords,
        handleStop,
        ...rest
    },
    ref,
) {
    const { t } = useTranslation();
    const [inputValues, setInputValues] = useState([]);
    const [checkValues, setCheckValues] = useState([]);
    const [kq, setKq] = useState(null);

    const [result, setResult] = useState('wrong'); // no_check || right || wrong
    const [isShowResult, setIsShowResult] = useState(false);



    function handleOnClickContinue() {
        updateResult(kq, true);
    }
    function handleOnClickCheck() {
        const kq = findTheBestGrade();
        const type = getTypeOfResult(kq);
        notiCompleteAnAnswer(type);
        setResult(type);
        handleVibrate('strong');
        removeFocus(); // để ẩn bàn phím ảo
        setIsShowResult(true);
        setKq(kq);
    }

    function findTheBestGrade() {
        // sẽ có thể có nhiều series đáp án đúng
        const arr = [];
        question.answer.forEach((answers) => {
            // mỗi phần tử của answers là đáp án cho 1 chỗ trống
            const kq = [];
            for (let i = 0; i < answers.length; i++) {
                // answers[i] có thể là:
                // -- 1 chuỗi hoặc
                // -- 1 mảng chuỗi (tức là chỗ trống có nhiều đáp án đúng)
                let temp = false;
                if (Array.isArray(answers[i])) {
                    for (let k = 0; k < answers[i].length; k++) {
                        if (checkAnswer(answers[i][k], inputValues[i])) {
                            temp = true;
                            break;
                        }
                    }
                } else {
                    // chuỗi
                    if (checkAnswer(answers[i], inputValues[i])) {
                        temp = true;
                    }
                }
                kq.push(temp ? 'right' : 'wrong');
            }
            arr.push(kq);
        });

        let max = arr[0];
        let countRightMax = arr[0].filter(
            (element) => element === 'right',
        ).length;
        for (let i = 1; i < arr.length; i++) {
            const countRight = arr[i].filter(
                (element) => element === 'right',
            ).length;
            if (countRight > countRightMax) {
                countRightMax = countRight;
                max = arr[i];
            }
        }
        // const tempArr = [];
        // for(let k = 0; k < max.length; k++) {
        //     tempArr.push();
        // }
        setCheckValues(max);
        return { count: max.length, correct: countRightMax };
    }

    const removeFocus = () => {
        // Lấy phần tử hiện đang focus
        const focusedElement = document.activeElement;
        // Kiểm tra nếu phần tử đang focus là input hoặc textarea
        if (
            focusedElement.tagName === 'INPUT' ||
            focusedElement.tagName === 'TEXTAREA'
        ) {
            // Gọi phương thức blur() để làm mất focus
            focusedElement.blur();
        }
    };

    const handleInputChange = (index, value) => {
        setInputValues((prevValues) => {
            const newValues = [...prevValues];
            newValues[index] = value;
            return newValues;
        });
    };

    function handleOnClickAnswer(e, list) {
        handleVibrate('slight');
        console.log('list', list);
        setInputValues(getSingleAnswerList(list));
    }

    const handleKeyDown = (event, index) => {
        //console.log('event.key', event.key);
        if (event.key === 'Enter') {
            event.preventDefault();
            // console.log('event.target', event.target);
            if (index < inputValues.length - 1) {
                document
                    .querySelectorAll('input', 'textarea')
                [index + 1].focus();
            } else {
                handleOnClickCheck();
            }
        }
    };

    const renderContent = () => {
        const sentence = question.content;
        const regex = /______\d?/;
        const parts = sentence.split(regex);
        const arrBlanks = sentence.match(/______\d?/g) || [];

        return parts.reduce((acc, part, index) => {
            // console.log('part', part);
            const list = splitText(part);
            // console.log('list', list);
            for (let i = 0; i < list.length; i++) {
                acc.push(
                    list[i] === '\n' ? (
                        <div
                            key={`text-${index}-${i}`}
                            className={clsx(styles.break)}
                        ></div>
                    ) : (
                        <div key={`text-${index}-${i}`}>
                            {list[i] === ' ' ? '\u00A0' : list[i]}
                        </div>
                    ),
                );
            }

            if (index < parts.length - 1) {
                if (arrBlanks[index] === '______') {
                    let w = 0;
                    if (question.blank) {
                        w = question.blank;
                    } else {
                        // tính chiều dài câu trả dài nhất
                        let len = 2;
                        question.answer.forEach(function (arr) {
                            const temp = getMaxLengthStringOfArray(arr[index]);
                            if (temp > len) len = temp;
                        });
                        // console.log('len', len);
                        w = len * 12 + 'px';
                    }
                    acc.push(
                        <input
                            className={clsx(
                                styles.input,
                                checkValues[index] === 'wrong' && styles.wrong,
                                checkValues[index] === 'right' && styles.right,
                            )}
                            style={{ width: `${w}` }}
                            key={`input-${index}`}
                            type="text"
                            value={inputValues[index] || ''}
                            onChange={(e) =>
                                handleInputChange(index, e.target.value)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)}
                        />,
                    );
                } else {
                    let numRow = parseInt(
                        arrBlanks[index].replaceAll('______', ''),
                    );
                    acc.push(
                        <textarea
                            className={clsx(styles.textarea)}
                            key={`input-${index}`}
                            type="text"
                            value={inputValues[index] || ''}
                            onChange={(e) =>
                                handleInputChange(index, e.target.value)
                            }
                            autoComplete="off"
                            rows={numRow}
                            required
                            onKeyDown={(e) => handleKeyDown(e, index)}
                        />,
                    );
                }
            }
            return acc;
        }, []);
    };

    // quét và tìm và focus vào input đầu tiên, mỗi lần:
    //  db thay đổi
    // câu hỏi thay đổi
    // ẩn hiện kết quả thay đổi
    const focusRef = useRef(null);
    useEffect(() => {
        if (!isShowResult && focusRef.current) {
            const firstInput = focusRef.current.querySelector('input');
            if (firstInput) {
                firstInput.focus();
            } else {
                const firstInput = focusRef.current.querySelector('textarea');
                if (firstInput) firstInput.focus();
            }
        }
    }, [question, isShowResult]);

    // Mỗi khi question thay đổi, khởi tạo inputValues với số lượng input tương ứng
    useEffect(() => {
        const sentence = question.content;
        const numInputs = (sentence.match(/______\d?/g) || []).length;
        setInputValues(Array(numInputs).fill(''));
        setCheckValues(Array(numInputs).fill('normal'));
        setIsShowResult(false);
        if (question.type === 'blank-listening') {
            if (handlePlay)
                handlePlay(question.answer[0][0]);
        }
        if (question.defaultAnswer && question.defaultAnswer.length > 0) {
            setInputValues(getSingleAnswerList(question.defaultAnswer[0]));
        }
        // eslint-disable-next-line
    }, [question]);

    useEffect(() => {
        return () => {
            if (handleStop)
                handleStop();
        };
        // eslint-disable-next-line
    }, [])

    return (
        <div {...rest} className={clsx(styles.question, className)}>
            <div className={clsx(styles.images)}>
                {question.images.map((image, index) => (
                    <img key={image} src={image} alt={image} />
                ))}
            </div>
            {question.type === 'blank-listening' && (
                <div className={clsx(styles.audio)}>
                    <IconButton
                        status="primary"
                        className={clsx(styles.icon, 'primary')}
                        onClick={() => { if (handlePlay) handlePlay(question.answer[0][0]) }}
                    >
                        <i className="fa-solid fa-volume-high"></i>
                    </IconButton>
                    <IconButton
                        status="primary"
                        className={clsx(styles.icon)}
                        onClick={() => handlePlayByWords(question.answer[0][0])}
                    >
                        <i className="fa-solid fa-sleigh"></i>
                    </IconButton>
                </div>
            )}
            <div ref={focusRef} className={clsx(styles.content)}>
                {renderContent()}
            </div>

            {/* action */}
            {!isShowResult && (
                <div className={styles.action}>
                    <TextButton
                        disable={
                            inputValues.filter((input) => input !== '')
                                .length === 0
                        }
                        normal
                        onClick={handleOnClickCheck}
                    >
                        {t('check')}
                    </TextButton>
                </div>
            )}
            {/* result */}
            {isShowResult && (
                <ResultBox
                    question={question}
                    result={result}
                    handleOnClickContinue={handleOnClickContinue}
                    handleOnClickAnswer={handleOnClickAnswer}
                />
            )}
        </div>
    );
}
export default forwardRef(BlankQuestion);

const getSingleAnswerList = (list) => {
    const kq = [];
    list.forEach((answer) => {
        if (Array.isArray(answer)) kq.push(answer[0]);
        else kq.push(answer);
    });
    return kq;
};
